import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { CategoryData } from '../../store/manager/state'

@Component({
  props: {
    articleData: {
      type: Object, /* ArticleData */
      required: true
    }
  }
})
export default class PublishConfig extends Vue {
  name: 'PublishConfig'
  $store: Store<RootState>

  categoryId: number = -1

  get categoryData(): CategoryData[] {
    return this.$store.state.manager.categoryData
  }

  created(): void {
    this.initializeForm()
  }

  @Watch('articleData')
  initializeForm(): void {
    const article = this.$props.articleData
    this.categoryId = article.category.categoryId
  }

  submitEvent() {
    const submitConfigData = {
      category: {
        categoryId: this.categoryId
      }
    }
    return this.$emit('submit', submitConfigData)
  }

  close() {
    return this.$emit('close')
  }

  trackCategory(): void {
  }
}
